import { c as _c } from "react/compiler-runtime";
import TimeConstants from '@module/utils/item';
import dayjs from 'dayjs';
import { useRef } from 'react';
import { useFetchLivePlayMutationStore } from '../../stores/useFetchLivePlayMutationStore';
const useEventRankState = () => {
  const $ = _c(3);
  const playInfo = useFetchLivePlayMutationStore(_temp);
  const setPlayInfo = useFetchLivePlayMutationStore(_temp2);
  const timerRef = useRef(null);
  let t0;
  if ($[0] !== playInfo || $[1] !== setPlayInfo) {
    const updateEventRank = data => {
      const isExpired = dayjs().diff(data.endDateTime) > 0;
      if (!playInfo || isExpired || data.score < 1) {
        return;
      }
      setPlayInfo({
        ...playInfo,
        eventRank: data
      });
      timerRef.current = setTimeout(() => {
        setPlayInfo({
          ...playInfo,
          eventRank: {
            rank: 0,
            score: 0,
            endDateTime: ""
          }
        });
      }, TimeConstants.ONE_MINUTE + 5000);
    };
    t0 = {
      updateEventRank
    };
    $[0] = playInfo;
    $[1] = setPlayInfo;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default useEventRankState;
function _temp(state) {
  return state.data;
}
function _temp2(state_0) {
  return state_0.setData;
}